<template>
  <div ref="whole_page" class="w-full">

    <pick-language
      :isLanguageViewActive="isLanguageViewActive"
      :languages="languages"
      @languageSelected="languageSelected"
      :isStudent="isStudent"
      :isTeacher="isTeacher"
    />

    <pick-grade
      :isGradeViewActive="isGradeViewActive"
      :selectedLanguage="selectedLanguage"
      :grades="grades"
      @gradeSelected="gradeSelected"
      @backToPickLanguage="backToPickLanguage"
      :showComingSoon="showComingSoon"
    />
    
    <pick-subject
      :isSubjectViewActive="isSubjectViewActive"
      :selectedLanguage="selectedLanguage"
      :selectedGrade="selectedGrade"
      :subjects="subjects"
      :studentSubjects="studentSubjects"
      @subjectSelected="getModuleData"
      :cannotContinue="cannotContinue"
      :lastTopicData="lastTopicData"
      @backToPickLanguage="backToPickLanguage"
      @backToPickGrade="backToPickGrade"
      :isStudent="isStudent"
      :isTeacher="isTeacher"
      :showComingSoon="showComingSoon"
      :showNoSubjects="showNoSubjects"
      :isOverrideModeActive="isOverrideModeActive"
      @studentOverrideMode="studentOverrideMode"
      @starSubject="starSubject"
      @unstarSubject="unstarSubject"
      @viewRoster="viewRoster"
      @viewLibrary="viewLibrary"
      @viewClassrooms="viewClassrooms"
      :notifications="notifications"
      :studentGradeId="studentGradeId"
      @viewResources="viewResources"
      :isUserPremium ="isUserPremium"
      :activeSubscription="activeSubscription"
      @moveCourseUp="moveCourseUp"
      @moveCourseDown="moveCourseDown"
    />

    <pick-module
      :isModuleViewActive="isModuleViewActive && selectedSubject"
      :selectedLanguage="selectedLanguage"
      :selectedGrade="selectedGrade"
      :selectedSubject="selectedSubject"
      :modules="modules"
      @moduleSelected="moduleSelected"
      @backToPickLanguage="backToPickLanguage"
      @backToPickGrade="backToPickGrade"
      @backToPickSubject="backToPickSubject"
      :isStudent="isStudent"
      :showComingSoon="showComingSoon"
      @changeModuleCategoryUp="changeModuleCategoryUp"
      @changeModuleCategoryDown="changeModuleCategoryDown"
    />

    <pick-topic
      :isTopicViewActive="isTopicViewActive && selectedModule"
      :selectedLanguage="selectedLanguage"
      :selectedGrade="selectedGrade"
      :selectedSubject="selectedSubject"
      :selectedModule="selectedModule"
      :moduleData="moduleData"
      @topicSelected="topicSelected"
      @backToPickLanguage="backToPickLanguage"
      @backToPickGrade="backToPickGrade"
      @backToPickSubject="backToPickSubject"
      @backToPickModule="backToPickModule"
      :isStudent="isStudent"
      :isTeacher="isTeacher"
      @topicAdded="getModuleData"
      @topicRemoved="getModuleData"
      :key="pickTopicKey"
      @subjectSelectedReload="subjectSelectedReload"
    />

    <topic-content
      :isTopicContentViewActive="isTopicContentViewActive && selectedTopic"
      :selectedLanguage="selectedLanguage"
      :selectedGrade="selectedGrade"
      :selectedSubject="selectedSubject"
      :selectedModule="selectedModule"
      :selectedTopic="selectedTopic"
      @contentSelected="contentSelected"
      @backToPickLanguage="backToPickLanguage"
      @backToPickGrade="backToPickGrade"
      @backToPickSubject="backToPickSubject"
      @backToPickModule="backToPickModule"
      @backToPickTopic="backToPickTopic"
      :isStudent="isStudent"
      :isTeacher="isTeacher"
      :isUserPremium ="isUserPremium"
      :activeSubscription="activeSubscription"
    />
    
    <b-modal
      id="schoolProvinceModal"
      style="background-color: #00000094;"
      class="school-modal-color"
      ref="school-modal"
      cancel-variant="outline-secondary"
      ok-only
      ok-title="Submit"
      centered
      title="Provide Your School"
      :no-close-on-backdrop="true"
      @ok="submitSchool"
    >
      <b-form>
        <div id="school-province">
          <div id="provinceContainer" class="mt-1" v-show="!notInSchoolCheckbox">
            <p id="input-heading" style="padding-bottom: 8px;">
              <strong>Select Province</strong>
            </p>
            <div class="input-group wrap-input1 validate-input" style="flex-direction: row; flex-wrap: nowrap;">
              <div class="input-group-prepend" >
                <span style="border-color: transparent; background-color:#65bf57; border-top-left-radius: 6px; border-bottom-left-radius: 6px; max-height: 36px; color: white !important" class="input-group-text text-image"><feather-icon icon="MapIcon"></feather-icon></span>
              </div>
              <div class="autocomplete" style="width: 100%;">
                <input
                  style="background-color:#242F43; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 36px; width: 100%; border-color: transparent;"
                  placeholder=" Province"
                  v-model="search"
                  @input="onChange"
                  type="text"
                />
                <ul
                  style="max-width: 434px; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;"
                  v-show="isOpenProvince"
                  class="autocomplete-results"
                >
                  <li
                    v-for="(result, i) in results"
                    :key="i"
                    @click="setResult(result)"
                    class="autocomplete-result"
                  >
                    {{ result }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="schoolContainer" style="padding-top: 21px;" v-show="!schoolNotOnListCheckbox && !notInSchoolCheckbox">
            <p id="input-heading" style="padding-bottom: 8px;">
              <strong>Select School</strong>
            </p>
            <div class="input-group wrap-input1 validate-input" style="flex-direction: row; flex-wrap: nowrap;">
              <div class="input-group-prepend">
                <span style="border-color: transparent; background-color:#6ac054; border-top-left-radius: 6px; border-bottom-left-radius: 6px; max-height: 36px; color: white !important" class="input-group-text text-image"><feather-icon icon="MapPinIcon"></feather-icon></span>
              </div>
              <div class="autocomplete" style="width: 100%;">
                <input
                  style="background-color:#242F43; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 36px; width: 100%; border-color: transparent;"
                  placeholder=" School"
                  v-model="searchSchool"
                  @input="onChangeSchool"
                  type="text"
                />
                <ul
                  style="max-width: 434px; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;"
                  v-show="isOpenSchool"
                  class="autocomplete-results"
                >
                  <li
                    v-for="(schoolResult, i) in schoolResults"
                    :key="i"
                    @click="setSchoolResult(schoolResult)"
                    class="autocomplete-result"
                  >
                    {{ schoolResult.name}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="schoolContainer" style="padding-top: 21px;" v-show="schoolNotOnListCheckbox && !notInSchoolCheckbox">
            <p id="input-heading" style="padding-bottom: 8px;">
              <strong>Provide School Name</strong>
            </p>
            <div class="input-group wrap-input1 validate-input">
              <div class="input-group-prepend">
                <span style="background-color:#65bf57; border-color: transparent; border-top-left-radius: 6px; border-bottom-left-radius: 6px; max-height: 36px; color: white !important" class="input-group-text text-image"><feather-icon icon="MapPinIcon"></feather-icon></span>
              </div>
              <div >
                <input
                  style="background-color:#242F43; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 36px; width: 435px; border-color: transparent;"
                  placeholder=" School Name"
                  v-model="newSchoolName"
                  type="text"
                />
              </div>
            </div>
          </div>
          <div class="mb-2 text-center" style="margin-top: 20px; padding-left: 11px;" v-show="!notInSchoolCheckbox">
            <div class="row">
              <vs-checkbox v-model="schoolNotOnListCheckbox" color="success">My School is <strong>NOT</strong> on the list</vs-checkbox>
            </div>
          </div>
          <div class="mb-2 text-center" style="margin-top: 20px; padding-left: 11px;">
            <div class="row">
              <vs-checkbox v-model="notInSchoolCheckbox" color="success">I am <strong>NOT</strong> in a School</vs-checkbox>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>


<script>
import PickLanguage from "./ContentComponents/PickLanguage.vue";
import PickGrade from './ContentComponents/PickGrade.vue';
import PickSubject from "./ContentComponents/PickSubject.vue";
import PickModule from "./ContentComponents/PickModule.vue";
import PickTopic from "./ContentComponents/PickTopic.vue";
import TopicContent from "./ContentComponents/TopicContent.vue";
import moment from "moment";
export default {
  components: {
    PickLanguage,
    PickGrade,
    PickSubject,
    PickModule,
    PickTopic,
    TopicContent,
    moment,
  },
  computed:{
    cssVars(){
      return {
        '--font':this.childfont
      }
    }
  },
  data() {
    return {
      results: [],
      isOpenProvince: false,
      isOpenSchool: false,
      isUserPremium: false,
      childfont:5,
      cannotContinue: true,
      languages: [],
      grades: [],
      studentLanguageId: null,
      studentGradeId: null,
      subjects: [],
      moduleData: [],
      modules: [], //ModuleClassifications
      cachingMinutes: 60,
      selectedLanguage: "",
      selectedGrade: {},
      selectedSubject: {},
      selectedModule: {},
      selectedTopic: {},
      isLanguageViewActive: false,
      isGradeViewActive: false,
      isSubjectViewActive: false,
      isModuleViewActive: false,
      isTopicViewActive: false,
      isTopicContentViewActive: false,
      lastTopicData: null,
      isStudent: false,
      isTeacher: false,
      showComingSoon: false,
      isOverrideModeActive: false,
      showNoSubjects: false,
      studentSubjects: [],
      notifications: [],
      pickTopicKey: 0,
      logData: {},
      uuid: null,
      activeSubscription: {
        id: null,
        subscriptionTypeId: null,
        name: null,
        description: null,
        timeRemaining: null,
        subjectIds: []
      },
      school: "",
      provinces: ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", "Mpumalanga", "Northern Cape", "North West", "Western Cape"],
      searchKeyword: "",
      provinceOptions: "",
      search: '',
      searchSchool: '',
      newSchoolName: '',
      provinceId: 0,
      schoolList: [],
      schoolId: 0,
      schoolData: {
        schoolId: 0,
        provinceId: 0,
        schoolNotOnListCheckbox: false,
        notInSchool: false,
      },
      schoolNotOnListCheckbox: false,
      notInSchoolCheckbox: false,
      schoolResults: [],
    };
  },
  watch: {
    school :function(val){
      if(val.length > 2){
        this.myFunction(val)
      }
    }
  },
  methods: {
    studentOverrideMode() {
      var self = this;

      self.isOverrideModeActive = true;
      self.isSubjectViewActive = false;
      self.subjects = [];
      self.isLanguageViewActive = true;
      self.getLanguages();
    },
    openActions(e) {
      var elem = e.target.closest(".float-btn-group");
      if (elem) {
        elem.classList.toggle('open')
      }
    },
    getLanguages(languageParam, whenDone) {
      var self = this;
      self.showComingSoon = false;

      if(self.$route.params.selectedData) {
        self.selectedLanguage = languageParam;
        self.isLanguageViewActive = false;
        self.isGradeViewActive = true;
      }

      var temp = localStorage.getItem("languages");
      if (temp) self.languages = temp.split(",");

      var languageExpiryDate = localStorage.getItem("languageExpiryDate");

      if (whenDone && typeof whenDone == "function")
        whenDone();

      if (
        !self.languages ||
        !languageExpiryDate ||
        languageExpiryDate < new Date().getTime()
      ) {
        self.showLoadingOnElement('whole_page', 1, 'material');

        var onSuccess = function(response) {
          if (response.data && response.data.length >= 0) {
            self.languages = response.data;
            localStorage.setItem("languages", self.languages);

            var timestamp = new Date().getTime() + self.cachingMinutes * 60000;

            localStorage.setItem("languageExpiryDate", timestamp);

            if (whenDone && typeof whenDone == "function")
              whenDone();
          }
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGetAnon(self, "Language/GetLanguagesOnly?siteId=" + self.$getSiteId(), onSuccess, onFinally);
      }
    },
    getGrades(gradeParam, whenDone) {
      var self = this;
      self.showComingSoon = false;

      var temp_grades = [];

      if(self.$route.params.selectedData) {
        self.selectedGrade = gradeParam;
        self.isGradeViewActive = false;
        self.isSubjectViewActive = true;
      }

      var temp = localStorage.getItem("grades_" + self.selectedLanguage);
      if (temp) {
        temp_grades = JSON.parse(temp).sort((a, b) => a.name > b.name ? 1 : -1);
        self.grades = temp_grades.filter(function(item) { return item.name != null });
      }
      var gradeExpiryDate = localStorage.getItem("gradesExpiryDate_" + self.selectedLanguage);

      if (whenDone && typeof whenDone == "function")
        whenDone();

      self.showComingSoon = self.grades.length == 0 ? true : false;

      if (!self.grades || !gradeExpiryDate || gradeExpiryDate < new Date().getTime()) {
        self.showComingSoon = false;
        self.showLoadingOnElement('whole_page', 1, 'material');

        var onSuccess = function(response) {
          if (response.data && response.data.length >= 0) {
            temp_grades = response.data.sort((a, b) => a.name > b.name ? 1 : -1);
            self.grades = temp_grades.filter(function(item) { return item.name != null });
            
            localStorage.setItem("grades_" + self.selectedLanguage, JSON.stringify(self.grades));

            var timestamp = new Date().getTime() + self.cachingMinutes * 60000;

            localStorage.setItem("gradesExpiryDate_" + self.selectedLanguage, timestamp);

            if (whenDone && typeof whenDone == "function")
              whenDone();
          }
          self.showComingSoon = self.grades.length == 0 ? true : false;
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }

        self.$ajaxGetAnon(self, "CourseClassification/GetCourseClassificationsByLanguage?siteId=" + self.$getSiteId() + "&language=" + self.selectedLanguage, onSuccess, onFinally);
      }
    },
    getStudentSubjects() {
      var self = this;
      if (!self.activeSubscription.id || self.$getSiteId() == 21) {
        self.showNoSubjects = false;

        var onSuccess = function(response) {
          if (response.data && response.data.length >= 0) {
            self.studentSubjects = response.data.sort((a, b) =>
              a.name > b.name ? 1 : -1
            );

            var ids = self.studentSubjects.map(function(item) {
              return item.id;
            });
            self.getNotifications(ids);
          }
          self.showNoSubjects = self.studentSubjects.length == 0 ? true : false;
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };


        if(self.isStudent) {
          self.showLoadingOnElement('whole_page', 1, 'material');
          self.$ajaxGet(self, "StudentSubject/ListStudentSubjects", onSuccess, onFinally);
        }
      }
    },
    getSubjects(gradeIdParam, whenDone) {
      var self = this;
      self.showComingSoon = false;
      var gradeId = self.studentGradeId && !self.isOverrideModeActive ? self.studentGradeId : gradeIdParam ? gradeIdParam : self.selectedGrade.id;

      if(gradeIdParam == self.studentGradeId)
        self.isOverrideModeActive = false;

      if(self.isStudent) {
        var temp = localStorage.getItem("subjects_" + gradeId);
        if (temp) {
          self.subjects = JSON.parse(temp).sort((a, b) => a.number - b.number);

          if (self.activeSubscription.id && self.activeSubscription.subjectIds.length > 0) {
            self.studentSubjects = self.subjects.filter(x => self.activeSubscription.subjectIds.includes(x.id));

            self.subjects = self.subjects.sort((a, b) => a.number - b.number);
          }
        }
        var subjectExpiryDate = localStorage.getItem(
          "subjectsExpiryDate_" + gradeId
        );

        if (whenDone && typeof whenDone == "function")
          whenDone();

        self.showComingSoon = self.subjects.length == 0 ? true : false;

        if (
          !self.subjects ||
          !subjectExpiryDate ||
          subjectExpiryDate < new Date().getTime()
        ) {
          self.showComingSoon = false;
          self.showLoadingOnElement('whole_page', 1, 'material');

          var onSuccess = function(response) {
            if (response.data && response.data.length >= 0) {
              self.subjects = response.data.sort((a, b) => a.number - b.number);
              localStorage.setItem(
                "subjects_" + gradeId,
                JSON.stringify(self.subjects)
              );
              var timestamp = new Date().getTime() + self.cachingMinutes * 60000;

              localStorage.setItem("subjectsExpiryDate_" + gradeId, timestamp);

              if (self.activeSubscription.id && self.activeSubscription.subjectIds.length > 0) {
                self.studentSubjects = self.subjects.filter(x => self.activeSubscription.subjectIds.includes(x.id));
                self.subjects = self.subjects.sort((a, b) => a.number - b.number);
              }

              if (whenDone && typeof whenDone == "function")
                whenDone();
              
            }
            self.showComingSoon = self.subjects.length == 0 ? true : false;
          };

          var onFinally = function(response) {
            self.$vs.loading.close(self.$refs.whole_page.$el);
            // self.setTimeout(GetUserGrade(), 5000);
            
          };

          self.$ajaxGetAnon(self, "Course/GetCoursesByClassification?classificationId=" + gradeId + "&siteId=" + self.$getSiteId(), onSuccess, onFinally);
        }
      }
      else {
        self.showComingSoon = false;
        self.showLoadingOnElement('whole_page', 1, 'material');

        var onSuccess = function(response) {
          if (response.data && response.data.length >= 0) {
            self.subjects = response.data.sort((a, b) => a.number - b.number);

            if (self.activeSubscription.id && self.activeSubscription.subjectIds.length > 0) {
              self.studentSubjects = self.subjects.filter(x => self.activeSubscription.subjectIds.includes(x.id));
              self.subjects = self.subjects.sort((a, b) => a.number - b.number);
            }

            if (whenDone && typeof whenDone == "function")
              whenDone();
          }
          self.showComingSoon = self.subjects.length == 0 ? true : false;
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGetAnon(self, "Course/Admin/GetCoursesByClassification?classificationId=" + gradeId + "&siteId=" + self.$getSiteId(), onSuccess, onFinally);
      }
    },
    GetUserGrade(){
      var self = this;
      var courseClassificationId = JSON.parse(localStorage.getItem('userInfo')).courseClassificationId;
      var onSuccess = response =>{
        localStorage.setItem("userGrade", JSON.stringify(response.data));
      }
      self.$ajaxGet(self, `Course/GetGrade?courseClassificationId=${courseClassificationId}`, onSuccess);
    },
    getModuleData(subject, icon, whenDone, topicsChanged,reload = false) {
      var self = this;
      self.showComingSoon = false;
      self.selectedSubject = subject;
      self.selectedSubject.icon = icon;
      
      if (!topicsChanged) {
        self.isSubjectViewActive = false;
        self.isModuleViewActive = true;
      }

      if(self.isStudent) {
        var temp = localStorage.getItem("moduleData_" + subject.id);
        if (temp) {
          
          self.moduleData = JSON.parse(temp);

          var temp_modules = [];

          self.modules = [];

          temp_modules = self.moduleData.map(function(item) {
            return {
              id: item.moduleCategoryId,
              name: item.moduleCategoryName,
              number: item.moduleCategoryNumber,
              createdOn: item.moduleCategoryCreatedOn,
              termId: item.moduleGroupId,
              hasNewContent: item.hasNewContent,
              isLibraryResource: item.id,
              libraryResourceTypeId: item.libraryResourceTypeId,
              producer: item.producer,
              author: item.author,
              url: item.url,
              coverPageUrl: item.coverPageUrl,
              genreName: item.genreName,
              summary: item.summary,
              isPremium: item.isPremium,
              moduleNumber: item.moduleNumber,
            };
          });

          temp_modules.forEach(_module => {
            if (
              self.modules.filter(function(item) {
                return _module.id == item.id;
              }).length == 0 && _module.id != null && _module.hasNewContent
            )
              self.modules.push(_module);
          });

          temp_modules.forEach(_module => {
            if (
              self.modules.filter(function(item) {
                return _module.id == item.id;
              }).length == 0 && _module.id != null && !_module.hasNewContent
            )
              self.modules.push(_module);
          });

          self.modules = self.modules.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn));

          if (whenDone && typeof whenDone == "function")
            whenDone();

          self.showComingSoon = self.modules.length == 0 ? true : false;
        }

        var moduleDataExpiryDate = localStorage.getItem(
          "moduleDataExpiryDate_" + subject.id
        );

        if (!self.moduleData || !moduleDataExpiryDate || reload || moduleDataExpiryDate < new Date().getTime()) {
          self.showComingSoon = false;
          self.showLoadingOnElement('whole_page', 1, 'material');

          var onSuccess = function(response) {
            if (response.data && response.data.length >= 0) {
              self.moduleData = response.data;
              localStorage.setItem(
                "moduleData_" + subject.id,
                JSON.stringify(self.moduleData)
              );

              var temp_modules = [];

              self.modules = [];

              temp_modules = self.moduleData.map(function(item) {
                return {
                  id: item.moduleCategoryId,
                  name: item.moduleCategoryName,
                  number: item.moduleCategoryNumber,
                  createdOn: item.moduleCategoryCreatedOn,
                  termId: item.moduleGroupId,
                  hasNewContent: item.hasNewContent,
                  isLibraryResource: item.id,
                  libraryResourceTypeId: item.libraryResourceTypeId,
                  producer: item.producer,
                  author: item.author,
                  url: item.url,
                  coverPageUrl: item.coverPageUrl,
                  genreName: item.genreName,
                  summary: item.summary,
                  forTrimmedDownCurriculum: item.forTrimmedDownCurriculum,
                  moduleNumber: item.moduleNumber,
                  isPremium: item.isPremium
                };
              });

              temp_modules.forEach(_module => {
                if (
                  self.modules.filter(function(item) {
                    return _module.id == item.id;
                  }).length == 0 && _module.id != null && _module.hasNewContent
                )
                  self.modules.push(_module);
              });

              temp_modules.forEach(_module => {
                if (
                  self.modules.filter(function(item) {
                    return _module.id == item.id;
                  }).length == 0 && _module.id != null && !_module.hasNewContent
                )
                  self.modules.push(_module);
              });

              self.modules = self.modules.sort((a, b) => a.number - b.number);

              var timestamp = new Date().getTime() + self.cachingMinutes * 60000;

              localStorage.setItem(
                "moduleDataExpiryDate_" + subject.id,
                timestamp
              );

              if (whenDone && typeof whenDone == "function")
                whenDone();
            }
            self.showComingSoon = self.modules.length == 0 ? true : false;
          };

          var onFinally = function(response) {
            self.$vs.loading.close(self.$refs.whole_page.$el);
          };

          self.$ajaxGetAnon(self, "Student/GetModuleData?subjectId=" + subject.id + "&siteId=" + self.$getSiteId(), onSuccess, onFinally);
        }
      }
      else {
        self.showComingSoon = false;
        self.showLoadingOnElement('whole_page', 1, 'material');

        var onSuccess = function(response) {
          if (response.data && response.data.length >= 0) {
            self.moduleData = response.data;

            var temp_modules = [];

            self.modules = [];

            temp_modules = self.moduleData.map(function(item) {
              return {
                id: item.moduleCategoryId,
                name: item.moduleCategoryName,
                number: item.moduleCategoryNumber,
                createdOn: item.moduleCategoryCreatedOn,
                termId: item.moduleGroupId,
                hasNewContent: item.hasNewContent,
                isLibraryResource: item.id,
                libraryResourceTypeId: item.libraryResourceTypeId,
                producer: item.producer,
                author: item.author,
                url: item.url,
                coverPageUrl: item.coverPageUrl,
                genreName: item.genreName,
                summary: item.summary,
                forTrimmedDownCurriculum: item.forTrimmedDownCurriculum,
                moduleNumber: item.moduleNumber,
                isPremium: item.isPremium
              };
            });

            temp_modules.forEach(_module => {
              if (
                self.modules.filter(function(item) {
                  return _module.id == item.id;
                }).length == 0 && _module.id != null && _module.hasNewContent
              )
                self.modules.push(_module);
            });

            temp_modules.forEach(_module => {
              if (
                self.modules.filter(function(item) {
                  return _module.id == item.id;
                }).length == 0 && _module.id != null && !_module.hasNewContent
              )
                self.modules.push(_module);
            });

            // self.modules = self.sortModules(self.modules);
            self.modules = self.modules.sort((a, b) => a.number - b.number);

            if (whenDone && typeof whenDone == "function") {
              self.pickTopicKey += 1;
              whenDone();
            }
          }
          self.showComingSoon = self.modules.length == 0 ? true : false;
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGet(self, "Module/Admin/GetModuleData?subjectId=" + subject.id, onSuccess, onFinally);
      }
    },
    sortModules(modules) {
      var blah = modules.sort((a, b) => moment(new Date(a.createdOn).toISOString()).isBefore(moment(new Date(b.createdOn).toISOString())) ? 1 : -1);
    },
    languageSelected(language) {
      this.selectedLanguage = language;
      this.getGrades();
      this.isLanguageViewActive = false;
      this.isGradeViewActive = true;
    },
    gradeSelected(grade) {
      this.selectedGrade = grade;
      this.getSubjects(grade.id);
      this.getStudentSubjects();
      this.isGradeViewActive = false;
      this.isSubjectViewActive = true;
      localStorage.setItem('selectedGrade',JSON.stringify(this.selectedGrade));
    },
    moduleSelected(module, whenDone) {
      this.selectedModule = module;
      this.isModuleViewActive = false;
      this.isTopicViewActive = true;

      if (whenDone && typeof whenDone == "function")
        whenDone();
    },
    topicSelected(topic) {
      localStorage.removeItem(`standaloneContent_${topic.id}`);
      localStorage.removeItem(`standaloneContentExpiryDate_${topic.id}`);
      this.selectedTopic = topic;
      this.isTopicViewActive = false;
      this.isTopicContentViewActive = true;
    },
    contentSelected(task, index, standaloneContentDto, selectedData) {
      
      localStorage.setItem("selectedData", JSON.stringify(selectedData));
      if (task.video) {
        this.$router.push({
          name: "VideoViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData,
            activeSubscription: this.activeSubscription
          },
          query:{"id":task.id}
        });
      }
      else if (task.document) {
        this.$router.push({
          name: "DocumentViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData,
            activeSubscription: this.activeSubscription
          },
          query:{"id":task.id}
        });
      } else if (task.podcast) {
        this.$router.push({
          name: "PodcastViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id}
        });
      } else if (task.liveStream) {
        this.$router.push({
          name: "LiveStreamViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id}
        });
      } else if (task.videoChat) {
        this.$router.push({
          name: "VideoChatPage",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id}
        });
      } else if (task.upload) {
        this.$router.push({
          name: "UploadViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id}
        });
      } else if (task.presentation) {
        this.$router.push({
          name: "PresentationViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id}
        });
      } else if (task.quiz){
        this.getQuizTask(task.quiz.id, selectedData.selectedTopic.id);
      } else if (task.externalLink){
        this.logExternalLink(task.externalLink.id, task.externalLink.url);
      }     
    },
    getQuizTask(taskId, moduleId) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');
      var onSuccess = function (response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
        self.$router.push({ name: "QuizTaskViewer", params: {
          taskId: taskId,
          moduleId: moduleId,
          quiz: response.data,
        },});
      };
      var onFinally = function(response) {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };

      self.$ajaxGet(self, "Student/GetQuizTask?moduleId=" + moduleId + "&quizTaskId=" + taskId, onSuccess, onFinally);
    },
    logExternalLink(taskId, url) {
      var self = this;
        
      self.uuid = self.$uuid.v4();
      self.logData.taskId = taskId;
      self.logData.logIdentifier = self.uuid;
      self.logData.toTaskId = null;
      self.logData.fromTaskId = null;

      var onSuccess = function(response) {
        self.$ajaxPost(self, "ExternalLinkTask/EndLogEntry", self.logData, function() { window.open(url, "_blank"); });
      };
      
      self.$ajaxPost(self, "ExternalLinkTask/StartLogEntry", self.logData, onSuccess);
    },
    playStory() {
      localStorage.setItem("currentModule", topic.id);
      self.$router.push({
        name: "DigiStoryViewer",
        params: {
          mode: "story",
          moduleId: topic.id,
          isStudent: "true",
          coins: 0,
          new: "true"
        }
      });
    },
    backToPickLanguage() {
      this.showComingSoon = false;
      this.grades = [];
      this.subjects = [];
      this.modules = [];
      this.isGradeViewActive = false;
      this.isSubjectViewActive = false;
      this.isModuleViewActive = false;
      this.isTopicViewActive = false;
      this.isTopicContentViewActive = false;

      this.isLanguageViewActive = true;
    },
    backToPickGrade() {
      this.showComingSoon = false;
      this.subjects = [];
      this.modules = [];
      this.isLanguageViewActive = false;
      this.isSubjectViewActive = false;
      this.isModuleViewActive = false;
      this.isTopicViewActive = false;
      this.isTopicContentViewActive = false;

      this.isGradeViewActive = true;
    },
    backToPickSubject() {
      this.showComingSoon = false;
      this.modules = [];
      this.isLanguageViewActive = false;
      this.isGradeViewActive = false;
      this.isModuleViewActive = false;
      this.isTopicViewActive = false;
      this.isTopicContentViewActive = false;

      this.isSubjectViewActive = true;
    },
    backToPickModule() {
      this.showComingSoon = false;
      this.isLanguageViewActive = false;
      this.isGradeViewActive = false;
      this.isSubjectViewActive = false;
      this.isTopicViewActive = false;
      this.isTopicContentViewActive = false;

      this.isModuleViewActive = true;
    },
    backToPickTopic() {
      this.showComingSoon = false;
      this.isLanguageViewActive = false;
      this.isGradeViewActive = false;
      this.isSubjectViewActive = false;
      this.isModuleViewActive = false;
      this.isTopicContentViewActive = false;

      this.isTopicViewActive = true;
    },
    viewProfile() {
      let routeData = this.$router.resolve({ name: "DigiStudentProfile" });
      window.open(routeData.href, "_blank");
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    starSubject(subjectId) {
      var self = this;
      
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function(response) {
        self.getStudentSubjects();
        self.getSubjects();
      };

      self.$ajaxGet(self, "StudentSubject/LinkSubject?subjectId=" + subjectId, onSuccess);
    },
    unstarSubject(subjectId) {
      var self = this;
      
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function(response) {
        self.getStudentSubjects();
        self.getSubjects();
      };

      self.$ajaxGet(self, "StudentSubject/UnlinkSubject?subjectId=" + subjectId, onSuccess);
    },
    viewRoster() {
      var self = this;
      self.$router.push({
        name: "StudentRoster"
      });
    },
    viewLibrary() {
      var self = this;
      self.$router.push({
        name: "FullLibrary"
      });
    },
    viewClassrooms() {
      var self = this;
      self.$router.push({
        name: "StudentClassrooms"
      });
    },
    viewResources() {
      var self = this;
      self.$router.push({
        name: "StudentAdditionalResources"
      });
    },
    getNotifications(courses) {
      var self = this;

      var onSuccess = function(response) {
        self.notifications = response.data;
      };

      var courseIds = {
        ids: courses
      };

      self.$ajaxPost(self, "Student/GetNotifications", courseIds, onSuccess);
    },
    getCookieValue(a) {
      var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    },
    deleteCookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    getUserActiveSubscription(whenDone){
      var self = this;
      var onSuccess = function(response) {
        if (response.data) {
          self.activeSubscription = response.data;
          self.isUserPremium = response.data.isUserPremium;

          var grade = JSON.parse(localStorage.userInfo).courseClassificationId;
          localStorage.removeItem(`subjects_${grade}`);
          localStorage.removeItem(`subjectsExpiryDate_${grade}`);
        }
        whenDone();
      };
      self.$ajaxGet(self, "public/getactivesubscription" , onSuccess);
    },
    checkSubscriptionLangGrade(){
      var self = this;
    

      var onSuccess = response =>{
        if(!response.data){
          self.$router.push({name: "NeedMoreInfo", query:{lang:true,public:true}});
        } else{
          self.continuePageLoad(self);
        }
      }
    
      self.$ajaxGet(self, "public/checkSelectedLang" , onSuccess);
    },
    continuePageLoad(self){
    
    localStorage.removeItem("tid");

    self.isStudent = localStorage.getItem("isStudent");
    self.isStudent = self.isStudent == "true" ? true : false;

    self.isTeacher = localStorage.getItem("isTeacher");
    self.isTeacher = self.isTeacher == "true" ? true : false;

    if(localStorage.getItem("lastKnownTopic"))
      self.lastTopicData = JSON.parse(localStorage.getItem("lastKnownTopic"));

    if (self.lastTopicData) {
      if(Object.keys(self.lastTopicData.selectedData).length == 0)
        self.lastTopicData = null;
    }

    if (self.lastTopicData)
      self.cannotContinue = false;

    var userInfo = JSON.parse(localStorage.getItem("userInfo"));

    self.studentLanguageId = userInfo.languageId;
    self.studentGradeId = userInfo.courseClassificationId;

    self.getUserActiveSubscription(() => {
      if (self.studentLanguageId && self.studentGradeId) {
        self.getSubjects();
        self.getStudentSubjects();
        self.isSubjectViewActive = true;
      } else if (self.studentGradeId) {

      } else {
        self.getLanguages();
        self.isLanguageViewActive = true;
      }
      if(self.$route.params.selectedData && self.isStudent && (self.$route.params.navFromVideo || self.$route.params.navFromLesson)) {
        self.$route.params.navFromVideo = false;
        self.$route.params.navFromLesson = false;
        var selectedData = self.$route.params.selectedData;
        self.getModuleData(selectedData.selectedSubject, selectedData.selectedSubject.icon, function() {
          self.moduleSelected(selectedData.selectedModule, function() {
            self.topicSelected(selectedData.selectedTopic);
            
          })
        });
      }

      if(self.$route.params.selectedData && self.isStudent && self.$route.params.navFromLesson) {
        self.$route.params.navFromLesson = false;
        var selectedData = JSON.parse(self.$route.params.selectedData);
        self.getModuleData(selectedData.selectedSubject, selectedData.selectedSubject.icon, function() {
          self.moduleSelected(selectedData.selectedModule, function() {
            self.topicSelected(selectedData.selectedTopic)
          })
        });
      }

      if((self.$route.params.selectedData && (self.$route.params.navFromAddContent || self.$route.params.navFromBuilder)) || (self.$route.params.selectedData && (self.$route.params.navFromVideo || self.$route.params.navFromLesson) && !self.isStudent)) {
        self.$route.params.navFromAddContent = false;
        self.$route.params.navFromBuilder = false;
        self.$route.params.navFromVideo = false;
        self.$route.params.navFromLesson = false;
        var selectedData = self.$route.params.selectedData;
        self.getLanguages(selectedData.selectedLanguage, function() {
          self.getGrades(selectedData.selectedGrade, function() {
            self.getStudentSubjects();
            self.getSubjects(selectedData.selectedGrade.id, function() {
              self.getModuleData(selectedData.selectedSubject, selectedData.selectedSubject.icon, function() {
                self.moduleSelected(selectedData.selectedModule, function() {
                  self.topicSelected(selectedData.selectedTopic)
                })
              });
            })
          })
        })
      }

      if(self.$route.params.selectedData && self.$route.params.navFromResourceView) {
        self.$route.params.navFromResourceView = false;
        var selectedData = self.$route.params.selectedData;
        if (self.isStudent) {
          self.getStudentSubjects();
          self.getSubjects(self.studentGradeId, function() {
            self.getModuleData(selectedData.selectedSubject, selectedData.selectedSubject.icon);
          });
        }
        else {
          self.getLanguages(selectedData.selectedLanguage, function() {
            self.getGrades(selectedData.selectedGrade, function() {
              self.getStudentSubjects();
              self.getSubjects(selectedData.selectedGrade.id, function() {
                self.getModuleData(selectedData.selectedSubject, selectedData.selectedSubject.icon);
              });
            })
          })
        }
      }

      if(self.$route.params.selectedData && self.isStudent && self.$route.params.navFromSearchModule) {
        self.$route.params.navFromSearchModule = false;
        var selectedData = self.$route.params.selectedData;
        self.getStudentSubjects();
        self.getSubjects(self.studentGradeId, function() {
          self.getModuleData(selectedData.selectedSubject, selectedData.selectedSubject.icon, function() {
            self.moduleSelected(selectedData.selectedModule);
          });
        });
      }

      if(self.$route.params.selectedData && self.isStudent && self.$route.params.navFromSearchTopic) {
        self.$route.params.navFromSearchTopic = false;
        var selectedData = self.$route.params.selectedData;
        self.getStudentSubjects();
        self.getSubjects(self.studentGradeId, function() {
          self.getModuleData(selectedData.selectedSubject, selectedData.selectedSubject.icon, function() {
            self.moduleSelected(selectedData.selectedModule, function() {
              self.topicSelected(selectedData.selectedTopic);
            })
          });
        });
      }
      if(localStorage.getItem("selectedData")){
        localStorage.removeItem("selectedData");
      }
    });
    this.userHasSchool();

  },
    showSchoolModal(){
      this.$refs['school-modal'].show()
    },
    filterResults() {
      if(this.search.length>=1){
        this.results = this.provinces.filter(item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
        this.isOpenProvince = true;
      }
      else{
        this.isOpenProvince = false;
      }
    },
    onChange() {
      this.filterResults();
    },
    setResult(result) {
      this.search = result;
      this.isOpenProvince = false;
      this.provinceId = this.provinces.indexOf(result);
      this.provinceId = this.provinceId + 1;
    },
    onChangeSchool() {
      this.filterSchool()
      this.isOpenSchool = true;
    },
    setSchoolResult(schoolResult) {
      this.searchSchool = schoolResult.name;
      this.isOpenSchool = false;
      this.schoolId = schoolResult.id;
      
    },

    filterSchool() {
      var self = this;
      if ((this.searchSchool.length >= 4)) {
        var onSuccess = response => {
          self.schoolList = response.data;
          if (response.data.length >= 1) {
            self.schoolResults = self.schoolList.map(x => {return{name: x.name, id: x.id}});
          }
        }
        var onFinally = response => {
        }
        self.$ajaxGetAnon(self,"User/GetSchoolByProvince?provinceId=" + this.provinceId + "&searchTerm=" + this.searchSchool, onSuccess, onFinally);
      }
    },

    submitSchool(){
      if(this.schoolNotOnListCheckbox){
        this.createNewSchool();
      }
      else{
        var self = this;
        var onSuccess = function(response) {
          self.$vs.notify({
            title:'School Information',
            color: "success",
            text: "Submitted!",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });    
        };
        self.schoolData.notInSchool = self.notInSchoolCheckbox;
        self.schoolData.provinceId = self.provinceId;
        self.schoolData.schoolId = self.schoolId;
        self.$ajaxPost(self, "User/UpdateSchool", self.schoolData, onSuccess);
      }
    },
    userHasSchool(){
      var self = this;
      var onSuccess = (response) => {
        if(!response.data && self.isStudent && self.$getSiteId() == 8)
        {
          //this.showSchoolModal();
        }
      };
      //self.$ajaxGet(self, "User/HasSelectedSchool", onSuccess);
    },
    createNewSchool(){
      var self = this;
      var onSuccess = function(response) {
        self.schoolData.schoolId = response.data;
        self.schoolData.provinceId = self.provinceId;
        self.schoolData.schoolNotOnListCheckbox = self.schoolNotOnListCheckbox;
        var onSuccess = function(response) {  
          self.$vs.notify({
            title:'School Information',
            color: "success",
            text: "Submitted!",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });    
        };
        self.$ajaxPost(self, "User/UpdateSchool", self.schoolData, onSuccess);
      };
      self.$ajaxGetAnon(self,"School/AddSchool?newSchoolName=" + self.newSchoolName, onSuccess);
    },
    moveCourseUp(index){
      var self = this;
      var oldIndex = self.subjects[index].number ;
      self.subjects[index].number = self.subjects[index - 1].number;
      self.subjects[index - 1].number = oldIndex;
      self.subjects = self.subjects.sort((a, b) => a.number - b.number);
    },
    moveCourseDown(index){
      var self = this;
      var oldIndex = self.subjects[index].number ;
      self.subjects[index].number = self.subjects[index + 1].number;
      self.subjects[index + 1].number = oldIndex;
      self.subjects = self.subjects.sort((a, b) => a.number - b.number);
    },
    changeModuleCategoryUp(index){
      var self = this;
      var oldIndex = self.modules.filter(x => !x.libraryResourceTypeId)[index].number ;
      self.modules.filter(x => !x.libraryResourceTypeId)[index].number = self.modules.filter(x => !x.libraryResourceTypeId)[index -1].number;
      self.modules.filter(x => !x.libraryResourceTypeId)[index-1].number = oldIndex;
      self.modules = self.modules.sort((a, b) => a.number - b.number);
    },
    changeModuleCategoryDown(index){
      var self = this;
      var oldIndex = self.modules.filter(x => !x.libraryResourceTypeId)[index].number ;
      self.modules.filter(x => !x.libraryResourceTypeId)[index].number = self.modules.filter(x => !x.libraryResourceTypeId)[index + 1].number;
      self.modules.filter(x => !x.libraryResourceTypeId)[index + 1].number = oldIndex;
      self.modules = self.modules.sort((a, b) => a.number - b.number);
    },
    subjectSelectedReload(subject,icon){
      var self = this;
      self.getModuleData(subject, icon,()=>{},()=>{},true)
    },
    getValidSubscription(){
      var self = this;
      var onSuccess = response =>{
        localStorage.setItem("subscriptionPermissions",response.data)
      }
      self.$ajaxGet(self, `GetSub/Permissions` , onSuccess);
    },
    checkCurrentLangAndGrade(){
      var self = this;
      var userInfo = JSON.parse(localStorage.getItem("userInfo"));

      var onSuccess = response =>{
        if(response.data.item1 != 0){
          var userInfo = JSON.parse(localStorage.getItem("userInfo"));
          userInfo.languageId = parseInt(response.data.item2);
          userInfo.isStudent = true;
          userInfo.courseClassificationId = parseInt(response.data.item1);

          userInfo.sitePermissions.filter(c=>c.siteId == self.$getSiteIdWithContent()).forEach(element => {
            element.languageId = response.data.item2;
            element.courseClassificationId = response.data.item1;
          });

          localStorage.setItem("userInfo", JSON.stringify(userInfo));

          window.location.reload();
        }
      }
    
      var onFinally = response =>{

      }
    
      self.$ajaxGet(self, `Student/VerifyLang?languageId=${userInfo.languageId}&gradeId=${userInfo.courseClassificationId}` , onSuccess, onFinally);
    },
  },
  mounted() {
    var isStudent = localStorage.getItem("isStudent");
    if(isStudent == true || isStudent == "true"){
      this.GetUserGrade();
    }
    localStorage.removeItem("selectedCategory");
    localStorage.removeItem("selectedResource");
    localStorage.removeItem("selectedGrade");
    
    this.$setColors();
    if ( this.getCookieValue("autoRedirect")){
      var temp = JSON.parse(this.getCookieValue("autoRedirect"));
      this.$router.push({name: temp.url, query:{id:temp.id}});
      this.deleteCookie("autoRedirect");
      return;
    }

    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    if(self.$route.query.ref == "public"){
      self.checkCurrentLangAndGrade();
      self.checkSubscriptionLangGrade();
    } else {
      self.continuePageLoad(self);
    }

    if(!localStorage.getItem("subscriptionPermissions")){
      this.getValidSubscription();
    }
  },
  created() {
    if(!localStorage.getItem("userInfo")) {
      window.location.replace("/login");
    }
  },
};
</script>

<style lang="scss">

  .fab_direction-up {
    right: 5vw;
    bottom: 4vh;
    z-index: 999;
    position: fixed;
  }

  .text-image{
    padding: 5px !important;
  }

  .text_box_image{
    padding: 17px !important;
  }


  .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #fffdfd;
    height: 120px;
    min-height: 1em;
    max-height: 6em;    
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
    background-color: #191d33;
    color: white;
  }

</style>
